/**
 * The token of a chatbot that answers only signed-in people (ADR-0072): the
 * platform's support assistant, inserted by the platform itself with
 * `data-auth-token` on its tag. Sent with every request as `X-Chatbot-Auth`;
 * a customer's widget has none and sends nothing.
 */

let token = '';

/** Reads it off the script tag, once, at boot. */
export function setAuthToken(script) {
  token = (script?.dataset?.authToken || '').trim();
}

/** The header to add to a request, or nothing. */
export function authHeaders() {
  return token ? { 'X-Chatbot-Auth': token } : {};
}

/**
 * Who the stored conversation belongs to (ADR-0074). The support assistant's
 * thread is kept per client and person — read from the token's public part —
 * so another administrator on the same browser starts their own conversation.
 * The signature is the server's to check; this only picks a storage key.
 * A visitors' widget has no token: ''.
 */
export function storageScope() {
  if (!token) return '';
  try {
    const part = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(part + '='.repeat((4 - (part.length % 4)) % 4)));
    return `:c${Number(payload.cid) || 0}u${Number(payload.uid) || 0}`;
  } catch {
    return ':unknown';
  }
}

